import React from "react";
import { useAdminPortal } from "../AdminPortalContext";
import PricingAdminDashboard from "../../../../../components/admin/PricingAdminDashboard";

/**
 * Admin Pricing Page
 * Wrapper component that integrates PricingAdminDashboard
 * with the admin portal context (theme, token, etc.)
 */
const AdminPricingPage = () => {
  const { theme, token } = useAdminPortal();
  const isDarkTheme = theme === "dark";

  return (
    <div className="space-y-6">
      <section
        className={`rounded-[28px] border px-6 py-6 ${isDarkTheme ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white shadow-[0_16px_44px_rgba(15,23,42,0.05)]"}`}
      >
        <div className="mb-6">
          <h2 className="text-2xl font-bold">Pricing Management</h2>
          <p
            className={`mt-2 text-sm leading-6 ${isDarkTheme ? "text-slate-400" : "text-slate-500"}`}
          >
            Manage pricing plans, FAQs, and pricing page settings. Changes are
            reflected in real-time on the pricing page.
          </p>
        </div>

        {/* Pricing Admin Dashboard Component */}
        <PricingAdminDashboard isDarkTheme={isDarkTheme} token={token} />
      </section>
    </div>
  );
};

export default AdminPricingPage;
